import { render, staticRenderFns } from "./FlowReviewGrid.vue?vue&type=template&id=4818aac4&scoped=true&"
import script from "./FlowReviewGrid.vue?vue&type=script&lang=ts&"
export * from "./FlowReviewGrid.vue?vue&type=script&lang=ts&"
import style0 from "./FlowReviewGrid.vue?vue&type=style&index=0&id=4818aac4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4818aac4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VChip,VIcon,VTextField,VTooltip})
